import { File } from '../../../../../../graphql/graphql';
import React from 'react';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../../Enums/Theme.enum';
import useLoading from '../../../../../Base/Hooks/useLoading';
import apiClient from '../../../../../../Services/ApiClient';
import useApiClient from '../../../../../Base/Hooks/useApiClient';

interface Props {
	file?: File;
	title?: string;
}

const ManagerInsuranceCompaniesBatchDownload = ({
	file,
	title = 'component.insuranceCompanyBatch.table.downloadFile',
}: Props) => {
	const { isLoading, setIsLoading } = useLoading();
	const { displayError } = useApiClient();

	const downloadFile = async () => {
		if (!file?.id || !file?.userId) {
			return;
		}

		setIsLoading(true);
		try {
			const response = await apiClient.get(
				`/files/${file.userId}/${file.id}?download`,
				{ responseType: 'blob', catchError: false },
			);

			const blob = new Blob([response.data]);
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = file.name || 'download';
			link.click();
			window.URL.revokeObjectURL(link.href);
		} catch (e) {
			displayError(e);
		} finally {
			setIsLoading(false);
		}
	};

	if (!file || !file.userId) return null;

	return (
		<LinkButton
			title={title}
			theme={Theme.BLUE}
			onClick={downloadFile}
			isLoading={isLoading}
		/>
	);
};

export default ManagerInsuranceCompaniesBatchDownload;
